<main class="h-full w-full min-h-0">
    <div
        class="h-full min-h-0 flex flex-col divide-y divide-gray-200 dark:divide-zinc-700 overflow-hidden rounded-lg bg-white dark:bg-gray-800 shadow card-container-pale-no-padding">
        <div class="px-2 py-3 flex-0 flex flex-row items-center justify-between shadow shrink-0">
            <div>
                <h3 class="text-sm font-semibold text-primary">Creator lists</h3>
                <p class="mt-1 text-xs text-secondary">All screening lists for this brand</p>
            </div>
        </div>

        <div class="flex flex-col gap-y-4 flex-1 min-h-0 overflow-hidden">
            @if (allLists().length) {
            <div class="flex flex-col flex-1 min-h-0 overflow-hidden">
                <div class="flex-1 min-h-0 overflow-y-auto overflow-x-auto scrollbar-transparent">
                    <table class="table-fixed w-full min-w-full divide-y divide-gray-300 dark:divide-gray-700">
                        <thead class="bg-gray-100 dark:bg-gray-900/50 sticky top-0 z-10">
                            <tr>
                                <th scope="col"
                                    class="py-2 pr-3 pl-2 text-left text-sm font-semibold whitespace-nowrap text-primary">
                                    Name
                                </th>
                                <th scope="col"
                                    class="w-[33%] max-w-[33%] px-2 py-3.5 text-left text-sm font-semibold text-primary">
                                    Description
                                </th>
                                <th scope="col"
                                    class="px-2 py-3.5 text-left text-sm font-semibold whitespace-nowrap text-primary">
                                    Creator count
                                </th>
                                <th scope="col"
                                    class="px-2 py-3.5 text-left text-sm font-semibold whitespace-nowrap text-primary">
                                    Created date
                                </th>
                                <th scope="col"
                                    class="px-2 py-3.5 text-right text-sm font-semibold whitespace-nowrap text-primary">
                                    <span class="sr-only">Actions</span>
                                </th>
                            </tr>
                        </thead>
                        <tbody class="divide-y divide-gray-200 dark:divide-gray-700">
                            @for (list of allLists(); track list.id) {
                            <tr>
                                <td class="py-2 pr-3 pl-2 text-sm whitespace-nowrap text-primary">
                                    <div class="font-medium text-primary">{{ list.groupName }}</div>
                                </td>
                                <td class="w-[33%] max-w-[33%] min-w-0 px-2 py-2 text-sm text-secondary"
                                    [appTooltip]="list.groupDescription || ''" position="bottom">
                                    <div class="truncate" [attr.title]="list.groupDescription || null">
                                        {{ list.groupDescription || '—' }}</div>
                                </td>
                                <td class="px-2 py-2 text-sm whitespace-nowrap text-primary">
                                    {{ getCreatorCount(list) }}
                                </td>
                                <td class="px-2 py-2 text-sm whitespace-nowrap text-primary">
                                    {{ formatListDate(list) }}
                                </td>
                                <td class="px-2 py-2 text-sm whitespace-nowrap text-right text-primary">
                                    <button (click)="goToListDetails(list)" type="button"
                                        [appTooltip]="'View List Details'" position="top" class="btn-fab-primary">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round"
                                            class="size-5">
                                            <path d="M5 12h14" />
                                            <path d="m12 5 7 7-7 7" />
                                        </svg>
                                    </button>
                                </td>
                            </tr>
                            }
                        </tbody>
                    </table>
                </div>
            </div>
            } @else {
            <div class="flex-1 flex items-center justify-center min-h-32 py-8">
                <div class="text-center">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                        stroke="currentColor" class="mx-auto size-12 text-gray-400 dark:text-gray-500">
                        <path stroke-linecap="round" stroke-linejoin="round"
                            d="M8.25 6.75h12M8.25 12h12m-12 4.5h12M3.75 6.75h.007v.008H3.75V6.75Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0ZM3.75 12h.007v.008H3.75V12Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm-.375 5.25h.007v.008H3.75v-.008Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z" />
                    </svg>
                    <h3 class="mt-2 text-sm font-semibold text-gray-900 dark:text-white">No creator lists</h3>
                    <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">Create a list to see it here.</p>
                </div>
            </div>
            }
        </div>
    </div>
</main>